import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import type { RootState } from '../../../store';
import type { BroadcastState } from './types';
import type { FileOrganization } from '../../Documents/documentsSlice/types';
import type { Chat, Org } from '../../ChatsList/chatListSlice/types';
import { tenantScopeReset } from '../../Organizations/OrganizationsSlice/tenantScopeReset';

const initialState: BroadcastState = {
  orgs: [],
  selectedOrgs: [],
  broadcastMsg: null,
  isLoading: false,
  error: null,
};

const broadcastSlice = createSlice({
  name: 'broadcast',
  initialState,
  reducers: {
    setOrgs: (state, action: PayloadAction<FileOrganization[]>) => {
      state.orgs = action.payload;
    },
    setSelectedOrgs: (state, action: PayloadAction<Org[]>) => {
      state.selectedOrgs = action.payload;
    },
    setBroadcastMsg: (state, action: PayloadAction<Chat>) => {
      state.broadcastMsg = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    removeOrg: (state, action: PayloadAction<number>) => {
      const selectedOrgs = state.selectedOrgs;
      state.selectedOrgs = _.filter(selectedOrgs, x => x.id !== action.payload);
    },
  },
  extraReducers: builder => {
    builder.addCase(tenantScopeReset, () => initialState);
  },
});

export const { setIsLoading, setOrgs, setSelectedOrgs, setBroadcastMsg, removeOrg, setError } =
  broadcastSlice.actions;

export const getOrgs = (state: RootState) => state.broadcast.orgs;
export const getSelectedOrgs = (state: RootState) => state.broadcast.selectedOrgs;
export const getIsLoading = (state: RootState) => state.broadcast.isLoading;

export default broadcastSlice.reducer;
